module.exports = __webpack_public_path__ + "static/media/MinimalCoding.8731564f.svg";